import AppRecord from './AppRecord.js'

class Fee extends AppRecord {
  resetMomerizedComputed(){
    this._entity_long_name = undefined
  }
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }
  get entity_long_name(){
    if(this._entity_long_name){return this._entity_long_name}
    if(this.entity){return this._entity_long_name = this.entity.long_name}
    return undefined
  }
  get id(){
    return `${this.entity_id}-${this.date}-${this.identifier}`
  }
  set id(v){
    v
  }
}

export default Fee
